import React from "react";
import MarketplaceBase from "./marketplace/MarketplaceBase";

// Standalone Home Moving marketplace section (separate from legacy orders).
export default function HomeMovingPanelScreen(props) {
  return <MarketplaceBase serviceType="home_moving" title="Evden Eve Taşıma" history={props.history} />;
}
